module.exports = __webpack_public_path__ + "static/media/morning.63f7a8b2.jpg";